import statusSlide1 from './status-slide-1.webp';
import statusSlide2 from './status-slide-2.webp';
import statusSlide3 from './status-slide-3.webp';
import gold777 from './777-gold.webp';
import percent from './percent-gold.webp';
import giftboxClosed from './giftbox-closed.webp';
import timeout from './timeout.webp';
import perks from './perks.webp';
import loyalty from './loyalty.webp';
import earning from './earning.webp';

export default {
  statusSlide1,
  statusSlide2,
  statusSlide3,
  gold777,
  percent,
  giftboxClosed,
  timeout,
  perks,
  loyalty,
  earning,
};
